export const BRAND_NAME = 'Kabir7net';
// Note: It is the main site url. Ex - Kabir7net.com, etc.
export const BRAND_DOMAIN = 'kabir7.net';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'kabir7.net';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';